export default __webpack_public_path__ + "static/media/rocket_anim_43.ae2da41b.png";